import { render } from "./BookVideocallPopup.vue?vue&type=template&id=1663ea2c"
import script from "./BookVideocallPopup.vue?vue&type=script&lang=js"
export * from "./BookVideocallPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__